import React, { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { Helmet, HelmetProvider } from 'react-helmet-async';

// Componentes
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/sections/HeroSection';
import AboutSection from '../components/sections/AboutSection';
import ServicesSection from '../components/sections/ServicesSection';
import GallerySection from '../components/sections/GallerySection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import ContactSection from '../components/sections/ContactSection';
import StructuredData from '../components/seo/StructuredData'; // Importe o novo componente

const HomePage = () => {
  const [siteSettings, setSiteSettings] = useState(null); // Inicia como nulo
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const docRef = doc(db, "siteContent", "main");
    const unsubscribe = onSnapshot(docRef, (doc) => {
      if (doc.exists()) {
        setSiteSettings(doc.data());
      }
      setIsReady(true);
      
      const preloader = document.getElementById('preloader');
      if (preloader) {
          preloader.style.opacity = '0';
          setTimeout(() => {
              preloader.style.display = 'none';
          }, 500);
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <HelmetProvider>
      {/* O Helmet agora busca as informações do estado, com um fallback estático */}
      <Helmet>
        <title>{siteSettings?.seoTitle || 'Hulk Cabeleireiro'}</title>
        <meta name="description" content={siteSettings?.seoDescription || 'A melhor barbearia da sua cidade.'} />
      </Helmet>
      
      {/* Componente de Dados Estruturados para SEO Local */}
      <StructuredData settings={siteSettings} />

      <div style={{ visibility: isReady ? 'visible' : 'hidden' }} className="bg-background text-text">
        <Header />
        <main>
          <HeroSection />
          <AboutSection />
          <ServicesSection />
          {siteSettings?.showGallery && <GallerySection />}
          <TestimonialsSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default HomePage;
